export default "__VITE_ASSET__CztjqoKA__"